module.exports = __webpack_public_path__ + "img/15.cec24b1d.png";